import React, { useEffect, useState } from "react";
import { X, MessageSquarePlus, Rocket } from "lucide-react";
import { BETA_BANNER } from "@/config/beta";

const STORAGE_KEY = `cbr_beta_banner_dismissed_v${BETA_BANNER.bannerVersion}`;

export default function BetaBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(STORAGE_KEY) !== "1");
    } catch (_) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try { localStorage.setItem(STORAGE_KEY, "1"); } catch (_) { /* noop */ }
    setVisible(false);
  };

  const openFeedback = () => {
    window.dispatchEvent(new CustomEvent("cbr:open-feedback"));
  };

  return (
    <div data-testid="beta-banner" className="bg-[#E63946] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-2.5 flex items-center gap-3">
        <Rocket className="w-4 h-4 shrink-0 hidden sm:block" />
        <p className="flex-1 text-xs sm:text-sm leading-snug">
          {BETA_BANNER.message}
        </p>
        <button
          data-testid="beta-banner-feedback"
          onClick={openFeedback}
          className="hidden sm:inline-flex items-center gap-1.5 shrink-0 bg-white/15 hover:bg-white/25 transition-colors px-3 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wider"
        >
          <MessageSquarePlus className="w-3.5 h-3.5" /> Share Feedback
        </button>
        <button
          data-testid="beta-banner-feedback-mobile"
          onClick={openFeedback}
          className="sm:hidden shrink-0 p-1.5 rounded-full bg-white/15 hover:bg-white/25 transition-colors"
          aria-label="Share feedback"
        >
          <MessageSquarePlus className="w-4 h-4" />
        </button>
        <button
          data-testid="beta-banner-dismiss"
          onClick={dismiss}
          className="shrink-0 p-1.5 rounded-full hover:bg-white/15 transition-colors"
          aria-label="Dismiss beta banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
